import { TemplateLink } from "./TemplateLink"

export default function PlusDeltaContent() {
  return (
    <>
      <h2>Origin &amp; history</h2>
      <p>
        Plus / Delta predates agile by decades. Its lineage runs through
        adult learning theory and the{" "}
        <a
          href="https://en.wikipedia.org/wiki/W._Edwards_Deming"
          target="_blank"
          rel="noopener noreferrer"
        >
          W. Edwards Deming
        </a>{" "}
        quality movement. The "delta" naming is deliberate, borrowed from
        math to frame improvement as change rather than complaint. You'll
        see it show up at the end of training sessions, workshops, and
        meetings across industries that never heard of a sprint.
      </p>

      <blockquote>
        Every system is perfectly designed to get the results it gets.
        <br />
        <em>&mdash; often attributed to W. Edwards Deming</em>
      </blockquote>

      <h2>When to use this format</h2>
      <p>
        Two columns. Five minutes. Use it as a meeting-end check-in, at the
        close of a workshop, or as your sprint retro when the team is
        exhausted and just needs to write down what happened. It's the
        retro equivalent of "any final thoughts before we wrap?", but
        structured enough that quiet people actually contribute.
      </p>

      <h2>When NOT to use this format</h2>
      <p>
        Don't use it as your only retrospective format. Plus / Delta is
        shallow by design; running it every sprint means your team never
        does the deeper reflection that catches slower-moving issues. Mix
        it in. A Plus / Delta three sprints in a row, then a{" "}
        <TemplateLink to="sailboat">Sailboat</TemplateLink>, then back.
      </p>

      <h2>How to run it</h2>
      <p>
        Silent writing for three to five minutes. No grouping ceremony;
        just read the items and pick one Delta the team commits to acting
        on before the next meeting. The commitment is the whole point;
        without it, Plus / Delta is a feelings check-in.
      </p>

      <h2>Common pitfalls</h2>
      <p>
        The Plus column becomes a compliment mirror. "The meeting was
        great!" "Everyone contributed!" Nice, but not useful. Push for
        Pluses that name a specific thing worth preserving: a specific
        behavior, decision, or moment that made the meeting work. Generic
        praise is background noise.
      </p>
    </>
  )
}
